import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import DisplayTable from "../Tables/FilterTable";
import { Box } from "@mui/material";
import SearchBoxSection from "../SearchBox/SearchBoxSection";
import { TabEnum } from "../Content";
import { toVariableNameFormat } from "../../../Helper/Helper";
import Loader from "../../utilities/Loader/Loader";
import {
  getStaffTimeMasterData,
  getDeliveryStaffProductivityMasterData,
  getStaffCostDeptMasterData,
  getServiceDistributionMasterData,
  getExternalCostsMasterData,
  getOverheadCostsMasterData,
  getWebCostsMasterData,
  getProductMarginMasterData,
  getRRCIAndTrainingPricingMasterData,
  getAdditionalCounselingPricingMasterData,
  getPathwaysPricingTableMasterData,
  getGWQPricingMasterData,
  getNPRTWPricingMasterData,
  getCurrencyMasterData,
  getEnhancedLandFAvailabilityMasterData
} from "../../../Actions/ManageDataAction";
const TableTab = ({
  reload,
  handleDownloadData,
  handleUpload,
  headers,
  rows,
  Tab,
  handleDownloadTemplate
}) => {
  const [rowData, setRowData] = useState([]);
  const [headerData, setHeaderData] = useState(headers);
  const dispatch = useDispatch();
  const [loadingState, setLoadingState] = useState(false);
  useEffect(() => {
    switch(Tab)
    {
      case TabEnum.STAFFTIME:GetStaffTimeMasterData();break;
      case TabEnum.STAFFPRODUCTIVITY:GetDeliveryStaffProductivityMasterData();break;
      case TabEnum.STAFFCOST:GetStaffCostDeptMasterData();break;
      case TabEnum.SERVICEDISTRIBUTION:GetServiceDistributionMasterData();break;
      case TabEnum.EXTERNALCOST:GetExternalCostsMasterData();break;
      case TabEnum.OVERHEADCOST:GetOverheadCostsMasterData();break;
      case TabEnum.WEBCOST:GetWebCostsMasterData();break;
      case TabEnum.MARGINTABLE:GetProductMarginMasterData();break;
      case TabEnum.RRCIANDTRAININGPRICING:GetRRCIAndTrainingPricingMasterData();break;
      case TabEnum.ADDITIONALCOUNSELINGPRICING:GetAdditionalCounselingPricingMasterData();break;
      case TabEnum.PATHWAYSPRICING:GetPathwaysPricingTableMasterData();break;
      case TabEnum.GWQPRICING:GetGWQPricingMasterData();break;
      case TabEnum.NPRTWPRICING:GetNPRTWPricingMasterData();break;
      case TabEnum.CURRENCY:GetCurrencyMasterData();break;
      case TabEnum.ENHANCEDLANDFAVAILABILITY:GetEnhancedLandFAvailabilityMasterData();break;
      default:setRowData(rows); break;
      }
  }, [reload]);
  //#region Get function
  function GetStaffTimeMasterData() {
    setLoadingState(true);
    try {
       
      dispatch(getStaffTimeMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetDeliveryStaffProductivityMasterData() {
    setLoadingState(true);
    try {
      dispatch(getDeliveryStaffProductivityMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetServiceDistributionMasterData() {
     
    setLoadingState(true);
    try {
      dispatch(getServiceDistributionMasterData())
        .then((data) => {
          
          if (data?.length != null) {
            const result = data.reduce((acc, obj) => {
              const {
                country,
                product,
                component,
                utilizationPercent,
                productVariation,
              } = obj;
              const existingRow = acc.find(
                (row) =>
                  row.country === country &&
                  row.product === product &&
                  row.productVariation === productVariation
              );
              if (!existingRow) {
                const newRow = { country, product, productVariation };
                newRow[toVariableNameFormat(component)] =
                  utilizationPercent;
                acc.push(newRow);
              } else {
                existingRow[toVariableNameFormat(component)] =
                  utilizationPercent;
              }
              return acc;
            }, []);
            const itemSet = new Set(data.sort((a,b)=>a?.displayOrder-b?.displayOrder).map(item => item?.component)?.filter(component => component !== undefined && component !== '' && component !== null));
            const newColumns = Array.from(itemSet).map((item) => ({
              id: toVariableNameFormat(item),
              header: item,
              percentage:true,
              showdecimals:true 
            }));
            setHeaderData( [
              ...headers,
              ...newColumns,
            ]);
            result.map((x) => {
              newColumns.map((y) => {
                x[y.id] = x[y.id] === undefined ?0 : x[y.id];
              });
            });
            console.log(newColumns);
            setRowData(result);
          }
          setLoadingState(false);
    
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetStaffCostDeptMasterData() {
    setLoadingState(true);
    try {
      dispatch(getStaffCostDeptMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetExternalCostsMasterData() {
    setLoadingState(true);
    try {
      dispatch(getExternalCostsMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetOverheadCostsMasterData() {
    setLoadingState(true);
    try {
      dispatch(getOverheadCostsMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetWebCostsMasterData() {
    setLoadingState(true);
    try {
      dispatch(getWebCostsMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(true);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(true);
       
    }
  }
  function GetProductMarginMasterData() {
    setLoadingState(true);
    try {
      dispatch(getProductMarginMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetRRCIAndTrainingPricingMasterData() {
    setLoadingState(true);
    try {
      dispatch(getRRCIAndTrainingPricingMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetAdditionalCounselingPricingMasterData() {
    setLoadingState(true);
    try {
      dispatch(getAdditionalCounselingPricingMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetPathwaysPricingTableMasterData() {
    setLoadingState(true);
    try {
      dispatch(getPathwaysPricingTableMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetGWQPricingMasterData() {
    setLoadingState(true);
    try {
      
      dispatch(getGWQPricingMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
           
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
       
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetNPRTWPricingMasterData() {
    setLoadingState(true);
    try {
      dispatch(getNPRTWPricingMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetCurrencyMasterData() {
    setLoadingState(true);
    try {
      dispatch(getCurrencyMasterData())
        .then((data) => {
          if (data?.length != null) {
             setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
  function GetEnhancedLandFAvailabilityMasterData() {
     
    setLoadingState(true);
    try {
      dispatch(getEnhancedLandFAvailabilityMasterData())
        .then((data) => {
          if (data?.length != null) {
            setRowData(data);
          }
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } catch (e) {
      console.log(e);
      setLoadingState(false);
       
    }
  }
//#endregion




  return (
    <>
      <Box className="boxWrapper">
          <Box className="tabWrapper">
            <Box className="tableWrapper">
              <div className="buttonTab">
                <SearchBoxSection
                  handleUpload={handleUpload}
                  handleDownloadData={handleDownloadData}
                  handleDownloadTemplate={handleDownloadTemplate}
                  data={rowData}
                  headers={headerData}
                />
              </div>
              <DisplayTable headers={headerData} rows={rowData} loading={loadingState} />
            </Box>
          </Box>
      </Box>
      {loadingState && <Loader open={loadingState} />}
      </>
  );
};

export default TableTab;
